import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchEventUpdateSocket } from "./systemDuck";
import { Settings } from "../actions/apiActions";
import { enqueueSnackbar } from "notistack";

export const settingsDefaultState = {
  GeneralSettings: {
    formattedEntries: {},
    error: "",
  },
  ResponseTimeSettings: {
    formattedEntries: {},
    error: "",
  },
  StabilitySettings: {
    formattedEntries: {},
    error: "",
  },
  PIDControllerSettings: {
    formattedEntries: {},
    error: "",
  },
  AutoZeroSettings: {
    isAutoZeroStart: false,
    fortmattedEntries: {},
    error: "",
  },
  DeviceSettings43i: {
    fortmattedEntries: {},
    error: "",
  },
  AnalogOutputSettings: {
    formattedEntries: {},
    error: "",
  },
  DeviceSettings60i: {
    formattedEntries: {},
    error: "",
  },
  CylinderSettings: {
    formattedEntries: {},
    error: "",
  },
  QAL3Settings: {
    isQal3Start: false,
    formattedEntries: {},
    error: "",
  },
  SO2ScrubberSettings: {
    formattedEntries: {},
    error: "",
  },
};

export const fetchSettingsAuth = createAsyncThunk(
  "settings/fetchSettingsAuth",
  async (params, thunk) => {
    const { systemId, args, t } = params;
    const { config } = thunk.getState().config[systemId].system;
    if (config) {
      try {
        const data =
          {
            customerId: config.CUSTOMER_ID,
            deviceId: config.DEVICE_ID,
            setting: args.setting,
          } || {};
        const response = await Settings.get(config.SETTING_URL, data);
        return {
          response: {
            ...response,
            jsonData: JSON.parse(response.jsonData),
          },
          systemId,
          settingName: args.stateName,
        };
      } catch (err) {
        return thunk.rejectWithValue({
          systemId,
          settingName: args.stateName,
          error: err.message,
          tFunc: t,
        });
      }
    }
  }
);

export const setSettingsAuth = createAsyncThunk(
  "settings/setSettingsAuth",
  async (params, thunk) => {
    const { systemId, formState, args, t } = params;
    const { config } = thunk.getState().config[systemId].system;
    if (config) {
      try {
        const data =
          {
            customerId: config.CUSTOMER_ID,
            deviceId: config.DEVICE_ID,
            setting: args.setting,
            jsonData: JSON.stringify(formState),
          } || {};
        const response = await Settings.post(config.SETTING_URL, data);
        return {
          response: formState,
          systemId,
          settingName: args.stateName,
          tFunc: t,
        };
      } catch (err) {
        enqueueSnackbar(t("Failed to save: " + args.stateName), { variant: "error" });
      }
    }
  }
);

const settingsSlice = createSlice({
  name: "settings",
  initialState: settingsDefaultState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEventUpdateSocket, (state, action) => {
        const { Element: element, Status: status } = action.payload.data;
        if (element === "AutoZero") {
          let isStart = false;
          if (status === "InProgress") {
            isStart = true;
          } else if (status === "Cancelled" || status === "Done") {
            isStart = false;
          }
          state.AutoZeroSettings.isAutoZeroStart = isStart;
        }

        if (element === "Qal3") {
          let isStart = false;
          if (status === "InProgress") {
            isStart = true;
          } else if (status === "Cancelled" || status === "Done") {
            isStart = false;
          }
          state.QAL3Settings.isQal3Start = isStart;
        }
      })
      .addCase(fetchSettingsAuth.fulfilled, (state, action) => {
        const { settingName, response } = action.payload;
        state[settingName] = {
          formattedEntries: response,
          error: "",
        };
      })
      .addCase(fetchSettingsAuth.rejected, (state, action) => {
        const { tFunc: t, settingName, error } = action.payload;
        state[settingName].error = error;
        //don't generate a toast message when statuscode is 400 //NOTE! in future this should be 404 (when backend supports it)
        if (!action.payload.error === "Request failed with status code 400") {
          enqueueSnackbar(t("Failed to load settings " + settingName), { variant: "error" });
        }
      })
      .addCase(setSettingsAuth.fulfilled, (state, action) => {
        const { settingName, response, tFunc: t } = action.payload;
        state[settingName] = {
          formattedEntries: response,
          error: "",
        };
        enqueueSnackbar(t("Save Success " + settingName), { variant: "success" });
      });
  },
});

export const { } = settingsSlice.actions;

export default settingsSlice.reducer;
